/* eslint-disable */
<template>
  <v-container class="text-left">
    <v-row class="text-left">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="primary"
          icon="mdi-cellphone-dock"
          inline
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="text-body-1 font-weight-bold mb-2">
                Создание заказа на оплату
              </h1>
            </div>
          </template>
          <v-card-title class="mt-n5">
            Информация о плательщике
          </v-card-title>
          <v-card-text class="text-caption mt-n1">
            <v-form v-model="valid.main">
              <v-row
                dense
              >
                <v-col
                  cols="12"
                  md="6"
                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.fullname"
                    prepend-icon="mdi-account"
                    label="ФИО"
                    :readonly="dialog.view || form.payer.id"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n5 xs"
                >
                  <v-autocomplete
                    v-model="selected.payer"
                    prepend-icon="mdi-account-search"
                    editable
                    :filter="name_filter"
                    :items="select.payers"
                    label="Поиск клиента"
                    :readonly="dialog.view"
                    clearable
                    @change="name_change"
                  >
                    <template v-slot:selection="{item}">
                      {{ item.name }}
                    </template>
                    <template v-slot:item="{item}">
                      <v-list
                        two-line
                        class="text-left"
                      >
                        <v-list-item-content>
                          <v-list-item-title> {{ item.fullname }} {{ item.doc.series }}-{{ item.doc.number }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.address }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-select
                    v-model="form.payer.doc.type"
                    prepend-icon="mdi-passport"
                    :items="select.doc_type"
                    label="Тип документа"
                    :readonly="dialog.view"
                    @change="form.payer.doc.series = '', form.payer.doc.number = ''"
                  />
                </v-col>
                <v-col
                  v-if="form.payer.doc.type!=14 && form.payer.doc.type!=21"
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.doc.series"
                    label="Серия документа"
                    :readonly="dialog.view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.doc.number"
                    :rules="[(v) => check_doc(form.payer.doc.type, v) || 'Неверное значение']"
                    label="Номер документа"
                    :readonly="dialog.view"
                  />
                </v-col>
                <v-col
                  v-if="form.payer.documents && form.payer.documents.length>1"
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-select
                    v-model="selected.doc"
                    prepend-icon="mdi-passport"
                    :items="form.payer.documents"
                    label="Документы плательщика"
                    :readonly="dialog.view"
                    return-object
                    item-text="type_name"
                    @change="doc_change"
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="mt-n5"
                >
                  <v-text-field
                    v-model="form.payer.address"
                    prepend-icon="mdi-map-marker"
                    name="address"
                    label="Адрес"
                    :readonly="dialog.view"
                    @input="address_input"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.phone"
                    prepend-icon="mdi-cellphone-basic"
                    label="Телефон (в формате 7XXXXXXXXX)"
                    :readonly="dialog.view"
                    type="phone"
                    :counter="11"
                    maxlength="11"
                    :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="form.payer.email"
                    prepend-icon="mdi-at"
                    label="E-mail"
                    :readonly="dialog.view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n3 xs"
                >
                  <v-row dense>
                    <v-col cols="12">
                      Информация о платеже
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n5"
                    >
                      <v-text-field
                        v-model="form.recipient.uin"
                        label="Уникальный индекс начисления (УИН)"
                        :readonly="dialog.view"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n5"
                    >
                      <v-text-field
                        v-model="form.recipient.kbk"
                        label="КБК"
                        :counter="20"
                        maxlength="20"
                        :rules="[(v) => check_doc('kbk', v) || 'Неверное значение']"
                        @input="check_comission"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 xs"
                    >
                      <v-text-field
                        v-model="form.recipient.oktmo"
                        label="ОКТМО"
                        maxlength="8"
                        :readonly="dialog.view"
                        @input="check_comission"
                      />
                      <!--<v-autocomplete
                        v-model="form.recipient.oktmo"
                        editable
                        :filter="oktmo_filter"
                        :items="select.oktmo"
                        item-value="number"
                        label="ОКТМО"
                        :readonly="dialog.view"
                        maxlength="8"
                        @input="check_comission"
                      >
                        <template v-slot:selection="{item}">
                          {{ item.number }}
                        </template>
                        <template v-slot:item="{item}">
                          <v-list
                            two-line
                            class="text-left"
                          >
                            <v-list-item-content>
                              <v-list-item-title> {{ item.number }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list>
                        </template>
                      </v-autocomplete>-->
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 mb-n5 xs"
                    >
                      <v-text-field
                        v-model="form.sum"
                        label="Сумма"
                        :readonly="dialog.view"
                        :hint="comission_hint"
                        persistent-hint
                        @input="check_comission"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="mt-n3 xs"
                >
                  <v-row dense>
                    <v-col
                      cols="12"
                      class="mt-3"
                    >
                      Назначение платежа
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="form.description"
                        label="Назначение"
                        rows="6"
                        :readonly="dialog.view"
                        :counter="210"
                        maxlength="210"
                        @input="check_comission"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-n5">
            <v-btn
              color="secondary"
              min-width="100"
              @click="dialog.show = false, load_payers(), selected = { doc: null, payer: null}"
            >
              Закрыть
            </v-btn>
            <v-btn
              v-if="dialog.create"
              class="text--right"
              color="primary"
              min-width="100"
              :disabled="!valid.main || !valid.recipient"
              @click="create(), selected = { doc: null, payer: null}"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
      <v-col

        cols="12"
        md="4"
      >
        <v-form v-model="valid.recipient">
          <v-row>
            <v-col cols="12">
              <base-material-card
                color="primary"
                icon="mdi-cellphone-dock"
                inline
              >
                <template v-slot:heading>
                  <div class="text-center">
                    <h1 class="text-body-1 font-weight-bold mb-2">
                      Информация о получателе
                    </h1>
                  </div>
                </template>
                <v-card-title class="mt-n7">
                  Реквизиты получателя
                </v-card-title>
                <v-card-text class="text-left mb-n10">
                  <v-row
                    dense
                  >
                    <v-col
                      class="mt-n5"
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.recipient.name_full"
                        name="recipient_name"
                        label="Наименование"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="recipient_input"
                      />
                    </v-col>
                    <v-col
                      class="mt-n5"
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.recipient.name"
                        label="Получатель"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="check_comission"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 xs"
                    >
                      <v-text-field

                        v-model="form.recipient.inn"
                        name="recipient_inn"
                        label="ИНН"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="recipient_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"

                      class="mt-n5 xs"
                    >
                      <v-text-field
                        v-model="form.recipient.kpp"
                        name="recipient_kpp"
                        label="КПП"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="recipient_input"
                      />
                    </v-col>

                    <v-col
                      cols="8"
                      class="mt-n5"
                    >
                      <v-text-field
                        v-model="form.recipient.accnumber"
                        label="Расчетный счет"
                        :readonly="dialog.view || !dialog.no_recipient"

                        @input="check_comission"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"

                      class="mt-n5 xs"
                    >
                      <v-text-field
                        v-model="form.recipient.bik"
                        name="bank_bik"
                        label="БИК"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="bank_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.recipient.bankname"
                        name="bank_name"
                        label="Банк получателя"
                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="bank_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="mt-n5 text-caption"
                    >
                      <v-text-field
                        v-model="form.recipient.ks"
                        name="bank_ks"
                        label="К/с"

                        :readonly="dialog.view || !dialog.no_recipient"
                        @input="bank_input"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </base-material-card>
            </v-col>
            <v-col
              cols="12"
              class="mt-n5"
            >
              <base-material-card
                color="primary"
                icon="mdi-cellphone-dock"
                inline
              >
                <template v-slot:heading>
                  <div class="text-center">
                    <h1 class="text-body-1 font-weight-bold mb-n2">
                      Действия
                    </h1>
                  </div>
                </template>
                <v-card-text class="text-center">
                  <v-row class="mt-n5 mb-n5">
                    <v-col

                      cols="12"
                      md="4"
                    >
                      <v-icon
                        size="30"
                        :disabled="!form.id"
                        color="primary"
                        @click="resend"
                      >
                        mdi-reload
                      </v-icon>
                      <br><span class="text-caption">Повторить</span>
                    </v-col>
                    <v-col

                      cols="12"
                      md="4"
                    >
                      <v-icon
                        size="30"
                        :disabled="form.state!=5000"
                        color="primary"
                        @click="receipt"
                      >
                        mdi-receipt
                      </v-icon>
                      <br><span class="text-caption">Квитанция</span>
                    </v-col>
                    <v-col

                      cols="12"
                      md="4"
                    >
                      <v-icon
                        size="30"
                        :disabled="!form.id"
                        color="primary"
                        @click="$emit('cancel'), $emit('close'), dialog.show = false"
                      >
                        mdi-file-undo
                      </v-icon>
                      <br><span
                        class="text-caption"
                      >Отозвать</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </base-material-card>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog
      v-model="confirm.show"
      max-width="250"
    >
      <v-container>
        <v-card>
          <v-card-title>Отозвать платеж?</v-card-title>
          <v-card-actions>
            <v-btn
              width="100"
              color="secondary"
              @click="confirm.show = false"
            >
              Назад
            </v-btn>
            <v-btn
              width="100"
              color="primary"
              @click="recall(confirm.item)"
            >
              Да
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
    <v-dialog
      v-model="state.show"
      max-width="450"
    >
      <v-container>
        <v-card>
          <v-card-title>Результат</v-card-title>
          <v-card-text class="text-h6 text-left">
            Статус заказа: <b>{{ dict.state[state.item.state] }}</b><br>
            Выберите дальнейшее действие
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col

                cols="12"
                md="6"
              >
                <v-icon
                  size="64"
                  color="primary"
                  @click="state.show = false, dialog.show = false, $emit('close'),$router.push('/client/order/list')"
                >
                  mdi-file-document
                </v-icon>
                <br>
                Перейти к списку заказов
              </v-col>
              <v-col

                cols="12"
                md="6"
              >
                <v-icon
                  size="64"
                  color="primary"
                  @click="state.show = false, dialog.show = false, $router.push('/client/order/create')"
                >
                  mdi-credit-card-outline
                </v-icon>
                <br>
                Перейти к оплате услуг
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
  </v-container>
</template>
<script>
  import $ from 'jquery'
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import { mask, tokens, TheMask } from 'vue-the-mask'
  export default {
    props: {
      service: {
        type: String,
      },
      form: {
        type: Object,
        default: function () {
          return {

            recipient: {
              name: '',
              name_full: '',
              inn: '',
              kpp: '',
              bankname: '',
              bik: '',
              ks: '',
            },
            payer: {
              doc: {
                type: '',
                series: '',
                number: '',
              },
              address: '',
              email: '',
              phone: '',
              inn: '',
            },
          }
        },
      },
      dialog: {
        type: Object,
        default: function () {
          return {
            show: false,
            create: true,
            view: false,
            no_recipient: false,
          }
        },
      },
    },
    data: () => {
      return {
        service_item: null,
        selected: {
          doc: null,
          payer: null,
        },
        valid: {
          main: false,
          recipient: false,
        },
        comission: 0,
        state: {
          show: false,
          item: {},
        },
        mask: {
          phone: '+7(###)###-##-##',
        },
        suggestion: {
          address: false,
          recipient: false,
          bank: false,
        },
        confirm: {
          item: {},
          show: false,
        },
        dict: {
          state: {
            2000: 'Принят',
            3000: 'В обработке',
            4000: 'Отложен',
            5000: 'Завершен',
            6000: 'Отвергнут',
            7000: 'Отозван',
          },
          mfc: {},
          doc_type: {
            1: 'Паспорт гражданина Российской Федерации',
            2: 'Свидетельство о рождении',
            3: 'Паспорт моряка (удостоверение личности моряка)',
            4: 'Удостоверение личности военнослужащего ',
            5: 'Военный билет военнослужащего',
            6: 'Временное удостоверение личности гражданина Российской Федерации',
            7: 'Справка об освобождении из мест лишения свободы',
            8: 'Паспорт иностранного гражданина либо иной документ, установленный федеральным законом или признаваемый в соответствии с международным договором Российской Федерации в качестве документа, удостоверяющего личность иностранного гражданина',
            9: 'Вид на жительство ',
            10: 'Разрешение на временное проживание (для лиц без гражданства)',
            11: 'Удостоверение беженца',
            12: 'Миграционная карта',
            13: 'Паспорт гражданина СССР',
            14: 'CНИЛС',
            21: 'ИНН',
            22: 'Водительское удостоверение',
            24: 'Свидетельство о регистрации транспортного средства в органах Министерства внутренних дел Российской Федерации',
            25: 'Охотничий билет',
            26: 'Разрешение на хранение и ношение охотничьего оружия',
            28: 'Загранпаспорт',
            29: 'Свидетельство о предоставлении временного убежища на территории Российской Федерации',
            30: 'Свидетельство о рассмотрении ходатайства по существу',
            99: 'Иной',
          },
        },
        select: {
           payers: [],
          doc_type: [
            { value: 1, text: "Паспорт гражданина Российской Федерации" },
            { value: 2, text: "Свидетельство о рождении" },
            { value: 3, text: "Паспорт моряка (удостоверение личности моряка)" },
            { value: 4, text: "Удостоверение личности военнослужащего " },
            { value: 5, text: "Военный билет военнослужащего" },
            { value: 6, text: "Временное удостоверение личности гражданина Российской Федерации" },
            { value: 7, text: "Справка об освобождении из мест лишения свободы" },
            { value: 8, text: "Паспорт иностранного гражданина либо иной документ, установленный федеральным законом или признаваемый в соответствии с международным договором Российской Федерации в качестве документа, удостоверяющего личность иностранного гражданина" },
            { value: 9, text: "Вид на жительство " },
            { value: 10, text: "Разрешение на временное проживание (для лиц без гражданства)" },
            { value: 11, text: "Удостоверение беженца" },
            { value: 12, text: "Миграционная карта" },
            { value: 13, text: "Паспорт гражданина СССР" },
            { value: 14, text: "CНИЛС" },
            { value: 21, text: "ИНН" },
            { value: 22, text: "Водительское удостоверение" },
            { value: 24, text: "Свидетельство о регистрации транспортного средства в органах Министерства внутренних дел Российской Федерации" },
            { value: 25, text: "Охотничий билет" },
            { value: 26, text: "Разрешение на хранение и ношение охотничьего оружия" },
            { value: 28, text: "Загранпаспорт" },
            { value: 29, text: "Свидетельство о предоставлении временного убежища на территории Российской Федерации" },
            { value: 30, text: "Свидетельство о рассмотрении ходатайства по существу" },
            { value: 99, text: "Иной" }
          ],
        },
      }
    },
    computed: {
      comission_hint: function () {
        this.check_comission()
        return 'Комиссия: ' + Number(this.comission).toFixed(2) + ', итого: ' + Number(Number(this.comission) + Number(this.form.sum)).toFixed(2)
      },
    },
    watch: {
      service: function () {
        this.load_service()
      },
    },
    mounted: function () {
      this.load_payers()
      this.load_service()
    },
    methods: {
      get_value: function (settings, key) {
        if (settings.filter(a => a.key == key)[0]) {
          return settings.filter(a => a.key == key)[0].default_value
        }
        return ''
      },
      doc_change: function (item) {
        this.form.payer.doc = JSON.parse(JSON.stringify(item))
      },
      name_change: function (item) {
        if (!item) {
          this.form.payer = {
            doc: {},
          }
        } else {
          this.form.payer = JSON.parse(JSON.stringify(item))
          this.selected.doc = this.form.payer.doc
        }
      },
      load_service: function () {
        if (this.service) {
          this.axios.post('/api/item/list', {
            id: this.service,
          })
            .then(response => {
              if (!response.data.error) {
                const service = response.data.data[0]
                if (service) {
                  const settings = service.settings
                  this.form.recipient.name = service.recipient_item.requisites.name// this.get_value(settings, 'recipient_name')
                  this.form.recipient.name_full = service.recipient_item.legal.name.full// this.get_value(settings, 'recipient_name')
                  this.form.recipient.name_short = service.recipient_item.name
                  this.form.recipient.inn = service.recipient_item.legal.inn// this.get_value(settings, 'recipient_inn')
                  this.form.recipient.kpp = service.recipient_item.legal.kpp// this.get_value(settings, 'recipient_kpp')
                  this.form.recipient.bankname = service.recipient_item.requisites.bank_name// this.get_value(settings, 'bank_name')
                  this.form.recipient.bik = service.recipient_item.requisites.bic// this.get_value(settings, 'bank_bic')
                  this.form.recipient.ks = service.recipient_item.requisites.ks// this.get_value(settings, 'bank_ks')
                  this.form.recipient.accnumber = service.recipient_item.requisites.rs// this.get_value(settings, 'account')
                  this.form.recipient.oktmo = this.get_value(settings, 'oktmo')
                  this.form.recipient.kbk = this.get_value(settings, 'kbk')
                  this.form.description = this.get_value(settings, 'dest')
                  this.form.recipient.uin = this.get_value(settings, 'uin')
                  this.form.client = service.client
                  this.service_item = service
                  console.log(this.form)
                }
              } else {
                this.$store.commit('snackbar', response.data.data)
              }
            })
            .catch(e => {
              this.$store.commit('snackbar', e)
            })
        } else {
            this.axios.post('/api/item/list', {
              charge: this.form.recipient.charge
            })
            .then(response => {
                if (!response.data.error) {
                  const service = response.data.data[0]
                  if (service) {
                    this.form.client = service.client
                    this.service_item = service
                    console.log(this.form)
                  }
                } else {
                  this.$store.commit('snackbar', response.data.data)
                }
              })
              .catch(e => {
                this.$store.commit("snackbar", e)
              })
        }
      },
      load_payers: function () {
        this.axios
          .post('/api/member/list', {
            client: this.form.client,
          })
          .then(response => {
            if (!response.data.error) {
              for (const x in response.data.data) {
                for (const y in response.data.data[x].documents) {
                  response.data.data[x].documents[y].type_name = this.dict.doc_type[response.data.data[x].documents[y].type]
                }
              }
              this.select.payers = response.data.data
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
      check_doc: function (type, number, bik) {
        if (type == 21) {
          const error = {}
          if (this.validateInn(number, error)) return true
          else return error.message
        }
        if (type == 14) {
          const error = {}
          if (this.validateSnils(number, error)) return true
          else return error.message
        }
        if (type == 'kpp') {
          const error = {}
          if (this.validateKpp(number, error)) return true
          else return error.message
        }
        if (type == 'rs') {
          const error = {}
          if (this.validateRs(number, bik, error)) return true
          else return error.message
        }
        if (type == 'ks') {
          const error = {}
          if (this.validateKs(number, bik, error)) return true
          else return error.message
        }
        return true
      },
      validateRs: function (rs, bik, error) {
        var result = false
        if (typeof rs === 'number') {
          rs = rs.toString()
        } else if (typeof rs !== 'string') {
          rs = ''
        }
        if (!rs.length) {
          error.code = 1
          error.message = 'Р/С пуст'
        } else if (/[^0-9]/.test(rs)) {
          error.code = 2
          error.message = 'Р/С может состоять только из цифр'
        } else if (rs.length !== 20) {
          error.code = 3
          error.message = 'Р/С может состоять только из 20 цифр'
        } else {
          var bikRs = bik.toString().slice(-3) + rs
          if (bik.toString().slice(-3) == '000' || bik.toString().slice(-3) == '001' || bik.toString().slice(-3) == '002') { bikRs = bik.toString().slice(4, 6).padStart(3, '0') + rs }
          var checksum = 0
          var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
          for (var i in coefficients) {
            checksum += coefficients[i] * (bikRs[i] % 10)
          }
          if (checksum % 10 === 0) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      validateKs (ks, bik, error) {
        var result = false
        if (this.validateBik(bik, error)) {
          if (typeof ks === 'number') {
            ks = ks.toString()
          } else if (typeof ks !== 'string') {
            ks = ''
          }
          if (!ks.length) {
            error.code = 1
            error.message = 'К/С пуст'
          } else if (/[^0-9]/.test(ks)) {
            error.code = 2
            error.message = 'К/С может состоять только из цифр'
          } else if (ks.length !== 20) {
            error.code = 3
            error.message = 'К/С может состоять только из 20 цифр'
          } else {
            var bikKs = '0' + bik.toString().slice(4, 6) + ks
            var checksum = 0
            var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
            for (var i in coefficients) {
              checksum += coefficients[i] * (bikKs[i] % 10)
            }
            if (checksum % 10 === 0) {
              result = true
            } else {
              error.code = 4
              error.message = 'Неправильное контрольное число'
            }
          }
        }
        return result
      },
      validateBik (bik, error) {
        var result = false
        if (typeof bik === 'number') {
          bik = bik.toString()
        } else if (typeof bik !== 'string') {
          bik = ''
        }
        if (!bik.length) {
          error.code = 1
          error.message = 'БИК пуст'
        } else if (/[^0-9]/.test(bik)) {
          error.code = 2
          error.message = 'БИК может состоять только из цифр'
        } else if (bik.length !== 9) {
          error.code = 3
          error.message = 'БИК может состоять только из 9 цифр'
        } else {
          result = true
        }
        return result
      },
      validateKpp (kpp, error) {
        var result = false
        if (typeof kpp === 'number') {
          kpp = kpp.toString()
        } else if (typeof kpp !== 'string') {
          kpp = ''
        }
        if (!kpp.length) {
          error.code = 1
          error.message = 'КПП пуст'
        } else if (kpp.length !== 9) {
          error.code = 2
          error.message = 'КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)'
        } else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(kpp)) {
          error.code = 3
          error.message = 'Неправильный формат КПП'
        } else {
          result = true
        }
        return result
      },
      validateSnils (snils, error) {
        var result = false
        if (typeof snils === 'number') {
          snils = snils.toString()
        } else if (typeof snils !== 'string') {
          snils = ''
        }
        if (!snils.length) {
          error.code = 1
          error.message = 'СНИЛС пуст'
        } else if (/[^0-9]/.test(snils)) {
          error.code = 2
          error.message = 'СНИЛС может состоять только из цифр'
        } else if (snils.length !== 11) {
          error.code = 3
          error.message = 'СНИЛС может состоять только из 11 цифр'
        } else {
          var sum = 0
          for (var i = 0; i < 9; i++) {
            sum += parseInt(snils[i]) * (9 - i)
          }
          var checkDigit = 0
          if (sum < 100) {
            checkDigit = sum
          } else if (sum > 101) {
            checkDigit = parseInt(sum % 101)
            if (checkDigit === 100) {
              checkDigit = 0
            }
          }
          if (checkDigit === parseInt(snils.slice(-2))) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      validateInn: function (inn, error) {
        var result = false
        if (typeof inn === 'number') {
          inn = inn.toString()
        } else if (typeof inn !== 'string') {
          inn = ''
        }
        if (!inn.length) {
          error.code = 1
          error.message = 'ИНН пуст'
        } else if (/[^0-9]/.test(inn)) {
          error.code = 2
          error.message = 'ИНН может состоять только из цифр'
        } else if ([10, 12].indexOf(inn.length) === -1) {
          error.code = 3
          error.message = 'ИНН может состоять только из 10 или 12 цифр'
        } else {
          var checkDigit = function (inn, coefficients) {
            var n = 0
            for (var i in coefficients) {
              n += coefficients[i] * inn[i]
            }
            return parseInt(n % 11 % 10)
          }
          switch (inn.length) {
            case 10:
              var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8])
              if (n10 === parseInt(inn[9])) {
                result = true
              }
              break
            case 12:
              var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
                result = true
              }
              break
          }
          if (!result) {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      check_comission: function () {
        this.axios
          .post('/api/order/comission', this.form)
          .then(response => {
            if (!response.data.error) {
              this.comission = Number(response.data.data)
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.message || 'Ошибка при сохранении данных'
              )
            }
          }
          )
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
      bank_input: function () {
        this.check_comission()
        if (!this.suggestion.bank) {
          this.suggestion.bank = true
          $('[name=bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.recipient.bankname = data.data.name.full || data.data.name.payment
              this.form.recipient.bik = data.data.bic
              this.form.recipient.ks = data.data.correspondent_account
            },
          })
          $('[name=bank_bik]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.recipient.bankname = data.data.name.full || data.data.name.payment
              this.form.recipient.bik = data.data.bic
              this.form.recipient.ks = data.data.correspondent_account
            },
          })
          $('[name=bank_ks]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.recipient.bankname = data.data.name.full || data.data.name.payment
              this.form.recipient.ks = data.data.ks
              this.form.recipient.bik = data.data.correspondent_account
            },
          })
        }
      },
      recipient_input: function () {
        this.check_comission()
        if (!this.suggestion.recipient) {
          this.suggestion.recipient = true
          $('[name=recipient_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.recipient.name = data.data.name.short_with_opf
              this.form.recipient.name_full = data.data.name.short_with_opf
              this.form.recipient.name_short = data.data.name.short
              this.form.recipient.inn = data.data.inn
              this.form.recipient.kpp = data.data.kpp
            },
          })
          $('[name=recipient_kpp]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.recipient.name = data.data.name.short_with_opf
              this.form.recipient.name_full = data.data.name.short_with_opf
              this.form.recipient.name_short = data.data.name.short
              this.form.recipient.inn = data.data.inn
              this.form.recipient.kpp = data.data.kpp
            },
          })
          $('[name=recipient_inn]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.recipient.name = data.data.name.short_with_opf
              this.form.recipient.name_full = data.data.name.short_with_opf
              this.form.recipient.name_short = data.data.name.short
              this.form.recipient.inn = data.data.inn
              this.form.recipient.kpp = data.data.kpp
            },
          })
        }
      },
      open_file: function (id) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/payments/receipt',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      resend: function () {
        this.form.id = ''
        this.form.state = 0
        this.dialog.create = true
        this.dialog.view = false
      },
      receipt: function () {
        for (const x in this.form.payments) {
          // if (this.form.payments[x].receipt) {
          this.open_file(this.form.payments[x].payment_order)
          // }
        }
      },
      recall: function (item) {
        this.axios
          .post('/api/orders/revoke', { orderid: item.id, date: item.date, time: item.time })
          .then(response => {
            if (!response.data.error) {
              this.confirm.show = false
              this.state.show = true
              this.state.item = { state: response.data.status }
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.message || 'Ошибка при сохранении данных'
              )
            }
          }
          )
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
      address_input: function () {
        if (!this.suggestion.address) {
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.payer.address = data.unrestricted_value
              this.form.payer.address_data = data.data
            },
          })
        }
      },
      name_filter: function (item, query, text) {
        if (item.fullname.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.doc && item.doc.series.indexOf(query.toUpperCase()) > -1) return true
        if (item.doc && item.doc.number.indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      oktmo_filter: function (item, query, text) {
        if (item.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      transform_order: function (form) {
        const item = this.service_item
        item.count = 1
        item.amount = form.sum
        // item.name = form.recipient.name
        item.client = form.client
        item.attributes = {
          recipient_name: form.recipient.name,
          recipient_name_full: form.recipient.name_full,
          recipient_name_short: form.recipient.name_short,
          recipient_inn: form.recipient.inn,
          recipient_kpp: form.recipient.kpp,
          bank_name: form.recipient.bankname,
          bank_bic: form.recipient.bik,
          bank_ks: form.recipient.ks,
          recipient_rs: form.recipient.accnumber,
          oktmo: form.recipient.oktmo,
          kbk: form.recipient.kbk,
          dest: form.description,
          uin: form.recipient.uin,
          payer_fio: form.payer.fullname,
          payer_address: form.payer.address,
          doc_type: form.payer.doc.type,
          payer_doc_series: form.payer.doc.series,
          payer_doc_number: form.payer.doc.number,
          payer_phone: form.payer.phone,
          payer_email: form.payer.email,
        }
        const order = {
          client: form.client,
          items: [
            item,
          ],
          member_item: form.payer,
          sum: {
            comission: Number(this.comission).toFixed(2),
            recipient: Number(form.sum).toFixed(2),
            full: (Number(form.sum) + Number(this.comission)).toFixed(2),
          },
        }
        return order
      },
      create: function () {
        let request = JSON.parse(JSON.stringify(this.form))
        request = this.transform_order(request)
        this.axios
          .post('/api/order/create/', request)
          .then(response => {
            this.load_payers()
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Успешно')
              this.state.show = true
              this.state.item = {
                state: 2000,
              }
              this.form = {
                recipient: {

                },
                payer: {
                  doc: {
                    type: '',
                    series: '',
                    number: '',
                  },
                },
              }
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.status_message || 'Ошибка при сохранении данных'
              )
            }
          })
          .catch(e => {
            this.load_payers()
            this.$store.commit('snackbar', e)
          })
      },
    },
  }
        </script>
<!--        <style>
  .v-textarea textarea {
    line-height: 1.2em;
  }
  .v-input input {
    max-height: 24px;
  }
</style>-->
